import { HelpViewer } from '@components/common/help-viewer.tsx';
import { universe_mode } from '@helpers/types.ts';
import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { Fragment, useCallback } from 'react';

interface IUniverseModeProps {
  station: string;
  country: string;
  value: Array<universe_mode>;
  onChange: (v: Array<universe_mode>) => void;
}

const UniverseMode = (props: IUniverseModeProps) => {
  const { value, onChange } = props;
  const onChangeStatus = useCallback(
    (_: any, v: any) => {
      onChange(v);
    },
    [onChange],
  );
  return (
    <Fragment>
      <Stack direction="row" spacing={2}>
        <ToggleButtonGroup
          value={value}
          onChange={onChangeStatus}
          size="small"
          fullWidth
        >
          <ToggleButton color="primary" value={universe_mode.station}>
            BODEGA
          </ToggleButton>
          <ToggleButton color="primary" value={universe_mode.linehaul}>
            LINEHAUL
          </ToggleButton>
        </ToggleButtonGroup>
        <HelpViewer>
          <div>
            <Typography fontSize={16} fontWeight={700}>
              BODEGA
            </Typography>
            <div className="pl-2">
              <Typography fontSize={14}>
                Todas las ordenes que ya se encuentran en la estación{' '}
                <Typography fontWeight="bold" display={'inline'}>
                  {props?.station}
                  <sup>{props?.country}</sup>
                </Typography>
                <br />
                no considera devolución
              </Typography>
            </div>
          </div>
          <div>
            <Typography fontSize={16} fontWeight={700}>
              LINEHAUL
            </Typography>
            <div className="pl-2">
              <Typography fontSize={14}>
                Todas las ordenes que tienen como destino la estación{' '}
                <Typography fontWeight="bold" display={'inline'}>
                  {props?.station}
                  <sup>{props?.country}</sup>
                </Typography>
                <br />
                no considera devolución, no hay hora estimada de llegada
              </Typography>
            </div>
          </div>
        </HelpViewer>
      </Stack>
    </Fragment>
  );
};

export default UniverseMode;
